import React from "react";

const Spinner = () => {

  const style = {
    marginTop: "20vh",
    fontSize: "1.5rem",
  }

  return (
    <div>
      <div className="d-flex justify-content-center" style={style}>
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  );
};

export default Spinner;
